import React, { useContext } from "react";
import SnackBarComp, { SnackBarCompV2 } from "../../components/snackBar"
import { TrackingContext } from "../../context/userTracking";
import { setSnackBarOption } from "../../store/actions/trackerAction";
import CommonTypo from "../../components/CommonTypo";

const TrackerSnackbar = () => {
    const { state: ITrackerState, dispatch: trackingDispatch } =
        useContext(TrackingContext);
    const { showSnakbar, snakbarMsg, msgType = 'success', snackbarversion } = ITrackerState
    const handleCloseSnakbar = () => {
        trackingDispatch(setSnackBarOption({
            showSnakbar: false,
            snakbarMsg: "",
            msgType: 'success'
        }))
    };
    return snackbarversion === 'v2' ? <SnackBarCompV2
        showSnakbar={showSnakbar}
        handleCloseSnakbar={() => {
            handleCloseSnakbar();
        }}

        snakbarMsg={<CommonTypo size={16} fontWeight={600} lineHeight={19.2} color="var(--color-text-primary)">{snakbarMsg}</CommonTypo>}
        type={msgType ? msgType : "success"}
        alertSx={{
            background: "var(--color-new-main)",
            boxShadow: "0px 4px 8px 0px #0000001A",
            padding: "16px",
            borderRadius: "12px",
            height: "52px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            "& .MuiAlert-icon": {
                marginRight: "0px"
            }
        }}
        icon={msgType === "success" ? <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.7883 7.46172C13.8757 7.54882 13.945 7.65231 13.9923 7.76626C14.0397 7.88022 14.064 8.00239 14.064 8.12578C14.064 8.24917 14.0397 8.37134 13.9923 8.4853C13.945 8.59925 13.8757 8.70275 13.7883 8.78984L9.41328 13.1648C9.32619 13.2522 9.22269 13.3216 9.10874 13.3689C8.99478 13.4162 8.87261 13.4406 8.74922 13.4406C8.62583 13.4406 8.50366 13.4162 8.3897 13.3689C8.27575 13.3216 8.17226 13.2522 8.08516 13.1648L6.21016 11.2898C6.12295 11.2026 6.05378 11.0991 6.00658 10.9852C5.95939 10.8712 5.9351 10.7491 5.9351 10.6258C5.9351 10.5025 5.95939 10.3803 6.00658 10.2664C6.05378 10.1525 6.12295 10.0489 6.21016 9.96172C6.29737 9.87451 6.40089 9.80534 6.51483 9.75814C6.62877 9.71095 6.75089 9.68666 6.87422 9.68666C6.99755 9.68666 7.11967 9.71095 7.23361 9.75814C7.34755 9.80534 7.45108 9.87451 7.53828 9.96172L8.75 11.1719L12.4617 7.45938C12.5489 7.37236 12.6525 7.3034 12.7664 7.25642C12.8803 7.20944 13.0023 7.18537 13.1255 7.18559C13.2487 7.18581 13.3706 7.21031 13.4844 7.25769C13.5981 7.30507 13.7014 7.3744 13.7883 7.46172ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31038 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10Z" fill="#3E4240" />
        </svg> : null
        }
    /> : <SnackBarComp
        showSnakbar={showSnakbar}
        handleCloseSnakbar={handleCloseSnakbar}
        snakbarMsg={snakbarMsg}
        type={msgType ? msgType : "success"}
    />
}
export default TrackerSnackbar